import ScenesMenu from "../../ScenesMenu";
import { TourSignal } from "../../../StickyTour/TourTypes";
import { useStickyTourStore } from "../../../../stores/stickyTourStore";
import { useSudowriteStore } from "src/stores/sudowriteStore";
import { useState } from "react";

function PostGeneratedIdleButtonGroup({ requesting, outOfQuota, sceneId, setScenes, prosePreflight, documentScenes, scene }) {
  const sendFlowSignal = useStickyTourStore((state) => state.sendFlowSignal);

  // Unlimited Sudowrite Experiment
  const isInUnlimitedExperiment = useSudowriteStore((state) => state.isInUnlimitedExperiment);
  const unlimitedExperimentVariation = useSudowriteStore((state) => state.unlimitedExperimentVariation);
  const [usedDraftCount, setUsedDraftCount] = useState(() => {
    return parseInt(localStorage.getItem("unlimited-sudowrite-experiment-used-draft"), 10) || 0;
  });

  const incrementUsedDraftCount = () => {
    if (isInUnlimitedExperiment && unlimitedExperimentVariation !== "control") {
      const cookieName = `unlimited-sudowrite-experiment-used-draft`;
      const cookieValue = parseInt(localStorage.getItem(cookieName), 10) || 0;
      const newValue = cookieValue + 1;
      localStorage.setItem(cookieName, newValue);
      setUsedDraftCount(newValue);
    }
  };

  return (
    <ScenesMenu
      documentScenes={documentScenes}
      disabled={requesting || outOfQuota}
      onClick={() => {
        sendFlowSignal(TourSignal.DRAFT_PROSE_GENERATE_CLICKED);
        prosePreflight();
        incrementUsedDraftCount();
      }}
      onSelect={(selectedScene) => {
        setScenes((draft) => {
          draft[sceneId].restartFromIndex = selectedScene;
        });
      }}
      toggled={scene?.isContinue}
      onToggle={(value) => {
        // this value has already been set by the click handler in the toggle, so don't invert it here
        setScenes((draft) => {
          draft[sceneId].isContinue = value;
        });
      }}
      selected={scene?.restartFromIndex ?? 0}
    />
  );
}

export default PostGeneratedIdleButtonGroup;
